import { Alert, Box, BoxProps } from '@mui/material';
import React, { forwardRef } from 'react';

interface TableWrapperProps extends Omit<BoxProps, 'ref'> {
    hasUnsavedChanges?: boolean;
    children?: React.ReactNode;
}

export const TableWrapper = forwardRef<unknown, TableWrapperProps>(
    ({ hasUnsavedChanges, children, sx, ...boxProps }, ref) => {
        return (
            <Box
                ref={ref}
                sx={[
                    {
                        marginTop: 2,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        gap: 2,
                    },
                    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
                ]}
                {...boxProps}
            >
                {hasUnsavedChanges && (
                    <Alert severity="info" variant="filled">
                        Unsaved changes are stored temporarily until the end of the day. Remember to save them to avoid
                        losing any progress!
                    </Alert>
                )}
                {children}
            </Box>
        );
    }
);
